// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: rgb(15, 18, 20);
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}


.new-row {
  background-color: #dfffdf; /* Light green */
  color: black;
}

.edited-row {
  background-color: #fff8dc; /* Light yellow */
  color: black;
}


.deleted-row {
  background-color: #ffdddd; /* Light red */
  color: black;
  
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE;aACW;AACb;;;AAGA;EACE,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;AACd;;AAEA;EACE,yBAAyB,EAAE,iBAAiB;EAC5C,YAAY;AACd;;;AAGA;EACE,yBAAyB,EAAE,cAAc;EACzC,YAAY;;AAEd","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background: rgb(15, 18, 20);\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n\n.new-row {\n  background-color: #dfffdf; /* Light green */\n  color: black;\n}\n\n.edited-row {\n  background-color: #fff8dc; /* Light yellow */\n  color: black;\n}\n\n\n.deleted-row {\n  background-color: #ffdddd; /* Light red */\n  color: black;\n  \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
